
import styled from 'styled-components';
import { SectionDemoProps } from './query';
import Button_v2 from '@/components/molecules/Button/index';
import Title_v2 from '@/components/molecules/Title/index';

import { CheckmarkCyan } from '@/public/img/icons';
import devices from '@/utilities/devices';
import { renderUnderline } from '@/utilities/functions';

// #region STYLE
const DemoSectionContainer = styled.div`
	display: flex;

	.features-container {
		width: 40%;
		.checkmark-row {
			align-items: flex-start;
			color: ${({ theme }) => theme.color.black};
			display: flex;
			padding: .7rem 0;
			> div {
				padding-right: .6rem;
			}
		}
	}

	.aside-container {
		width: 60%;
		> img {
			margin-bottom: .5rem;
			margin-left: -.5rem;
		}
	}

	@media screen and (${devices.mobile}) {
		flex-direction: column;
		.features-container {
			margin: 1rem 0;
			width: 100%;
		}
		.aside-container {
			width: 100%;
			> img {
				display: none;
			}
		}
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		flex-direction: column;
		.features-container {
			margin: 1rem 0;
			width: 100%;
		}
		.aside-container {
			width: 100%;
			> img {
				display: none;
			}
		}
	}
`;

const CustomButton = styled(Button_v2)`
	justify-content: flex-start !important;
`;
// #endregion

const SectionDemo = ({ sectionDemoData }: { sectionDemoData: SectionDemoProps }) => {
	return (
		<>
			<Title_v2
				align={sectionDemoData.title.alignedAt}
				underlineColor={sectionDemoData.title.underlineColor}
				padding='4rem 0 3rem 0'
			>
				{renderUnderline(sectionDemoData.title.titlePieces)}
			</Title_v2>
			<DemoSectionContainer>
				<div className='features-container'>
					{sectionDemoData.listOfFeatures.map(
						(feature, index) => (
							<div className='checkmark-row' key={index}>
								<div> <CheckmarkCyan /> </div>
								{feature}
							</div>
						),
					)}
				</div>

				<div className='aside-container'>
					<img
						alt={sectionDemoData.demoImage.data.attributes.alternativeText}
						src={sectionDemoData.demoImage.data.attributes.url}
						loading='lazy'
					/>

					<CustomButton
						gtm_id={sectionDemoData.button.trackerId}
						href={sectionDemoData.button.url}
						openOnNewTab={sectionDemoData.button.newTab}
						text={sectionDemoData.button.text}
						version={sectionDemoData.button.variant}
					/>
				</div>
			</DemoSectionContainer>
		</>
	);
};

export default SectionDemo;
